<div class="page">
	<div class="page-header">
		<div class="page-title-row">
			<h1 class="page-title">SO Gap Monitor</h1>
			<span class="page-subcount">Test only</span>
		</div>
		<p-button
			label="Refresh"
			icon="pi pi-refresh"
			[outlined]="true"
			[loading]="isLoading()"
			(onClick)="loadSalesOrders()"></p-button>
	</div>

	<div class="table-card">
		<div class="toolbar">
			<input
				pInputText
				type="search"
				class="search-input"
				placeholder="Search sales orders"
				aria-label="Search sales orders"
				[ngModel]="searchTerm()"
				(ngModelChange)="searchTerm.set($event)"/>
			<span class="record-count">{{ filteredOrders().length }} sales orders</span>
		</div>

		<p-table
			[value]="filteredOrders()"
			[loading]="isLoading()"
			dataKey="rowKey"
			[paginator]="true"
			[rows]="25"
			[rowsPerPageOptions]="[25, 50, 100]"
			[scrollable]="true"
			scrollHeight="flex"
			[rowHover]="true"
			styleClass="so-gap-table p-datatable-sm">
			<ng-template pTemplate="header">
				<tr>
					<th pSortableColumn="ticketNumber">
						Ticket
						<p-sortIcon field="ticketNumber"/>
					</th>
					<th pSortableColumn="name">
						Customer
						<p-sortIcon field="name"/>
					</th>
					<th pSortableColumn="nsStatus">
						Status
						<p-sortIcon field="nsStatus"/>
					</th>
					<th pSortableColumn="amount">
						Amount
						<p-sortIcon field="amount"/>
					</th>
					<th pSortableColumn="salesOrderDate">
						SO Date
						<p-sortIcon field="salesOrderDate"/>
					</th>
					<th></th>
				</tr>
			</ng-template>
			<ng-template
				let-order
				pTemplate="body">
				<tr (click)="openOrder(order)">
					<td>{{ order.ticketNumber }}</td>
					<td>{{ order.name }}</td>
					<td>{{ order.nsStatus }}</td>
					<td>{{ order.amount | currency }}</td>
					<td>{{ order.salesOrderDate }}</td>
					<td>
						<div class="issue-tags">
							@if (order.errors.length) {
								<p-tag
									[value]="order.errors.length + ' errors'"
									severity="danger"/>
							}
							@if (order.warnings.length) {
								<p-tag
									[value]="order.warnings.length + ' warnings'"
									severity="warn"/>
							}
						</div>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="emptymessage">
				<tr>
					<td colspan="9">No sales orders found.</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<p-dialog
	[header]="'Sales order ' + (selectedOrder()?.ticketNumber ?? '')"
	[visible]="detailOpen()"
	(visibleChange)="detailOpen.set($event)"
	[modal]="true"
	[dismissableMask]="true"
	appendTo="body"
	[style]="{ width: '42rem' }">
	@if (selectedOrder(); as order) {
		<dl class="detail-grid">
			<div>
				<dt>Ticket</dt>
				<dd>
					<a
						[style]="{ color: 'inherit' }"
						href="https://{{
							environment.netSuiteInstance.subdomain
						}}.app.netsuite.com/app/accounting/transactions/salesord.nl?id={{
							order.internalId
						}}&whence="
						target="_blank">
						{{ order.ticketNumber }}
					</a>
				</dd>
			</div>
			<div>
				<dt>Internal Id</dt>
				<dd>{{ order.internalId }}</dd>
			</div>
			<div>
				<dt>Customer</dt>
				<dd>{{ order.name }}</dd>
			</div>
			<div>
				<dt>Parent Company</dt>
				<dd>{{ order.parentCompany }}</dd>
			</div>
			<div>
				<dt>Status</dt>
				<dd>{{ order.nsStatus }}</dd>
			</div>
			<div>
				<dt>Amount</dt>
				<dd>{{ order.amount | currency }}</dd>
			</div>
			<div>
				<dt>SO Date</dt>
				<dd>{{ order.salesOrderDate }}</dd>
			</div>
			<div>
				<dt>PO</dt>
				<dd>{{ order.po }}</dd>
			</div>
			<div>
				<dt>AFE</dt>
				<dd>{{ order.afe }}</dd>
			</div>
			<div>
				<dt>Cost Center</dt>
				<dd>{{ order.costCenter }}</dd>
			</div>
			<div>
				<dt>Location</dt>
				<dd>{{ order.location }}</dd>
			</div>
			<div>
				<dt>Job Location</dt>
				<dd>{{ order.jobLocation }}</dd>
			</div>
			<div>
				<dt>Requisitioner</dt>
				<dd>{{ order.requisitioner }}</dd>
			</div>
			<div class="detail-wide">
				<dt>Description</dt>
				<dd>{{ order.description }}</dd>
			</div>
			<div>
				<dt>Line</dt>
				<dd>{{ order.lineNumber }}</dd>
			</div>
			<div>
				<dt>Service Dates</dt>
				<dd>{{ order.lineServiceDateFrom }} – {{ order.lineServiceDateTo }}</dd>
			</div>
		</dl>

		@if (order.errors.length) {
			<h2>Errors</h2>
			<ul>
				@for (error of order.errors; track error.field + error.message) {
					<li>{{ error.field }}: {{ error.message }}</li>
				}
			</ul>
		}

		@if (order.warnings.length) {
			<h2>Warnings</h2>
			<ul>
				@for (warning of order.warnings; track warning.field + warning.message) {
					<li>{{ warning.field }}: {{ warning.message }}</li>
				}
			</ul>
		}

		@if (order.tasks.length) {
			<h2>Existing Tasks</h2>
			<ul class="task-list">
				@for (task of order.tasks; track task.internalId) {
					<li>
						<span>{{ task.title }} ({{ task.status }})</span>
						@if (task.validationCode || task.validationField || task.validationMessage) {
							<dl class="task-validation">
								@if (task.validationCode) {
									<div>
										<dt>Code</dt>
										<dd>{{ task.validationCode }}</dd>
									</div>
								}
								@if (task.validationField) {
									<div>
										<dt>Field</dt>
										<dd>{{ task.validationField }}</dd>
									</div>
								}
								@if (task.validationMessage) {
									<div>
										<dt>Message</dt>
										<dd>{{ task.validationMessage }}</dd>
									</div>
								}
							</dl>
						}
					</li>
				}
			</ul>
		}

		<div class="detail-actions">
			<p-button
				label="Create Tasks"
				icon="pi pi-check"
				[styleClass]="'embark-bg-blue'"
				[loading]="isCreatingTasks()"
				(onClick)="createTasks()"></p-button>
		</div>
	}
</p-dialog>
